/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NewsEntrySourceReportPaginationSlice', 'model/NewsEntryFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/NewsEntrySourceReportPaginationSlice'), require('../model/NewsEntryFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntrySourceReportApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NewsEntrySourceReportPaginationSlice, root.ForStractionServiceApi.NewsEntryFilter);
  }
}(this, function(ApiClient, NewsEntrySourceReportPaginationSlice, NewsEntryFilter) {
  'use strict';

  /**
   * NewsEntrySourceReport service.
   * @module api/NewsEntrySourceReportApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new NewsEntrySourceReportApi. 
   * @alias module:api/NewsEntrySourceReportApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the newsEntrySourceReportDeleteGet operation.
     * @callback module:api/NewsEntrySourceReportApi~newsEntrySourceReportDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/NewsEntrySourceReportApi~newsEntrySourceReportDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.newsEntrySourceReportDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySourceReportDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling newsEntrySourceReportDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/NewsEntrySourceReport/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntrySourceReportDetectNewsSourceContentGet operation.
     * @callback module:api/NewsEntrySourceReportApi~newsEntrySourceReportDetectNewsSourceContentGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * detectNewsSourceContent
     * @param {String} _4SAPIAppID 
     * @param {String} query 
     * @param {module:api/NewsEntrySourceReportApi~newsEntrySourceReportDetectNewsSourceContentGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.newsEntrySourceReportDetectNewsSourceContentGet = function(_4SAPIAppID, query, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySourceReportDetectNewsSourceContentGet";
      }

      // verify the required parameter 'query' is set
      if (query == undefined || query == null) {
        throw "Missing the required parameter 'query' when calling newsEntrySourceReportDetectNewsSourceContentGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'query': query
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/NewsEntrySourceReport/detectNewsSourceContent', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntrySourceReportSearchMatchingSlicePut operation.
     * @callback module:api/NewsEntrySourceReportApi~newsEntrySourceReportSearchMatchingSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntrySourceReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchMatchingSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryFilter} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {Boolean} opts.excludeNewsless  (default to false)
     * @param {Integer} opts.maxNewsEntriesCount  (default to 0)
     * @param {module:api/NewsEntrySourceReportApi~newsEntrySourceReportSearchMatchingSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntrySourceReportPaginationSlice}
     */
    this.newsEntrySourceReportSearchMatchingSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySourceReportSearchMatchingSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntrySourceReportSearchMatchingSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order'],
        'excludeNewsless': opts['excludeNewsless'],
        'maxNewsEntriesCount': opts['maxNewsEntriesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntrySourceReportPaginationSlice;

      return this.apiClient.callApi(
        '/NewsEntrySourceReport/searchMatchingSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntrySourceReportTouchAllPut operation.
     * @callback module:api/NewsEntrySourceReportApi~newsEntrySourceReportTouchAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * touchAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/NewsEntrySourceReportApi~newsEntrySourceReportTouchAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.newsEntrySourceReportTouchAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySourceReportTouchAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntrySourceReportTouchAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/NewsEntrySourceReport/touchAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntrySourceReportTouchGet operation.
     * @callback module:api/NewsEntrySourceReportApi~newsEntrySourceReportTouchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * touch
     * @param {String} _4SAPIAppID 
     * @param {Integer} sourceID 
     * @param {module:api/NewsEntrySourceReportApi~newsEntrySourceReportTouchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.newsEntrySourceReportTouchGet = function(_4SAPIAppID, sourceID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntrySourceReportTouchGet";
      }

      // verify the required parameter 'sourceID' is set
      if (sourceID == undefined || sourceID == null) {
        throw "Missing the required parameter 'sourceID' when calling newsEntrySourceReportTouchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourceID': sourceID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/NewsEntrySourceReport/touch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
